<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"

    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>业务机构名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>业务时间:</label>
            <DtpDatePicker placeholder=" 请选择" class="item" v-model.trim='query.bizTimeRange' :editable='false'></DtpDatePicker>
          </div>
          <div class="queryItem">
            <label>开票时间:</label>
            <DtpDatePicker placeholder=" 请选择" class="item" v-model.trim='query.invoiceTimeRange' :editable='false'></DtpDatePicker>
          </div>
          <div class="queryItem">
            <label>暂估状态:</label>
            <lk-select class="item" v-model="query.payableStatus" clearable>
              <lk-option v-for="item in payableStatusList" :value="item.id" :key="item.id">
              {{ item.name }}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>付款状态:</label>
            <lk-select class="item" v-model="query.paymentStatus" clearable>
              <lk-option v-for="item in paymentStatusList" :value="item.id" :key="item.id">
              {{ item.name }}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch(false,getTotal)">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <exportAsync  class="btn" @on-click='handleExport' v-if="handlePermission('financeInReportExport')"></exportAsync>
        <div class="Report-total-container">
          <div class="Report-total-title">合计</div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">接收金额（不含税）:</div>
            <div class="Report-total-item-value">{{total.inAmountStr || 0}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">接收金额（含税）:</div>
            <div class="Report-total-item-value">{{total.inAmountWithTaxStr || 0}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">已匹配数量:</div>
            <div class="Report-total-item-value">{{total.matchNum || 0}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">已匹配金额:</div>
            <div class="Report-total-item-value">{{total.matchAmountStr || 0}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">未匹配数量:</div>
            <div class="Report-total-item-value">{{total.unMatchNum || 0}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">未匹配金额:</div>
            <div class="Report-total-item-value">{{total.unMatchAmountStr || 0}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">应付发票金额:</div>
            <div class="Report-total-item-value">{{total.invoiceAmountStr || 0}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">已付金额:</div>
            <div class="Report-total-item-value">{{total.paymentAmountStr || 0}}</div>
          </div>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import reportService from '@/services/report';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import exportAsync from '../../components/report/ExportAsync.vue';

export default {
  name: 'financeInReportList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, exportAsync,
  },
  data() {
    return {
      query: {
        invoiceTimeRange: [],
        bizTimeRange: [utils.getCurrentMonthTimestamp(), utils.getNextMonthTimestamp()],
        storeIdList: [],
        payableStatus: '',
        paymentStatus: '',
      },
      total: { reportBizFinance: {} },
      columns: [
        {
          title: '所属药房',
          key: 'storeName',
          minWidth: 116,
          maxHeight: 60,
        },
        {
          title: '业务单据号',
          key: 'purchaseOrderCode',
          minWidth: 116,
          maxHeight: 60,
        },
        {
          title: '采购员',
          key: 'purchaseUserName',
          minWidth: 116,
        },
        {
          title: '供应商',
          key: 'supplierName',
          minWidth: 116,
        },
        {
          title: '物料编码',
          key: 'goodsSerialCode',
          minWidth: 116,
        },
        {
          title: '物料名称',
          key: 'goodsApprovedName',
          minWidth: 116,
        },
        {
          title: '单位',
          key: 'minPkgUnitName',
          minWidth: 116,
        },
        {
          title: '采购数量',
          key: 'purchaseNum',
          minWidth: 116,
        },
        {
          title: '采购单价（不含税）',
          key: 'purchasePriceStr',
          minWidth: 116,
        },
        {
          title: '采购金额（不含税）',
          key: 'purchaseAmountStr',
          minWidth: 116,
        },
        {
          title: '接收日期',
          key: 'inTime',
          minWidth: 116,
        },
        {
          title: '接收号',
          key: 'inCode',
          minWidth: 116,
        },
        {
          title: '接收数量',
          key: 'inNumStr',
          minWidth: 116,
        },
        {
          title: '接收单价（不含税）',
          key: 'inPriceStr',
          minWidth: 116,
        },
        {
          title: '接收金额（不含税）',
          key: 'inAmountStr',
          minWidth: 116,
        },
        {
          title: '接收金额（含税）',
          key: 'inAmountWithTaxStr',
          minWidth: 116,
        },
        {
          title: '发票日期',
          key: 'invoiceDate',
          minWidth: 116,
        },
        {
          title: '发票编码',
          key: 'invoiceCode',
          minWidth: 116,
        },
        {
          title: '已匹配数量',
          key: 'matchNum',
          minWidth: 116,
        },
        {
          title: '已匹配金额',
          key: 'matchAmountStr',
          minWidth: 116,
        },
        {
          title: '未匹配数量',
          key: 'unMatchNum',
          minWidth: 116,
        },
        {
          title: '未匹配金额',
          key: 'unMatchAmountStr',
          minWidth: 116,
        },
        {
          title: '税率',
          key: 'inputTaxRateStr',
          minWidth: 116,
        },
        {
          title: '应付发票金额',
          key: 'invoiceAmountStr',
          minWidth: 116,
        },
        {
          title: '已付金额',
          key: 'paymentAmountStr',
          minWidth: 116,
        },
      ],
      tableData: [],
      payableStatusList: [{ id: 1, name: '已完结' }, { id: 2, name: '未完结' }],
      paymentStatusList: [{ id: 1, name: '完全付款' }, { id: 2, name: '未付' }],

    };
  },
  methods: {
    paramsChange() {
      if (this.params.bizTimeRange && this.params.bizTimeRange.length === 2) {
        this.params.bizStartTime = this.params.bizTimeRange[0];
        this.params.bizEndTime = this.params.bizTimeRange[1];
      }
      if (this.params.invoiceTimeRange && this.params.invoiceTimeRange.length === 2) {
        this.params.invoiceStartTime = this.params.invoiceTimeRange[0];
        this.params.invoiceEndTime = this.params.invoiceTimeRange[1];
      }
    },
    handleExport(info, func) {
      this.paramsChange();
      this.$store.commit('setDisableLoading', true);
      reportService.financeInReportExport(utils.deletePageAndSize(this.params))
        .then((res) => {
          if (res.data.status === 200) {
            func(res.data.data);
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          console.log(err);
          utils.handleError(err);
        });
    },
    getTotal() {
      this.paramsChange();

      reportService.getFinanceInReportTotal(utils.deletePageAndSize(this.params)).then((res) => {
        if (res.data.status === 200) {
          this.total = res.data.data || { reportBizFinance: {} };
          console.log(this.total);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        console.log(err);
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {};
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      this.paramsChange();
      reportService.getFinanceInReportList(this.params).then((res) => {
        if (res.data.status === 200 && res.data.data.list) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            item.inTime = utils.formatTime(item.inTime, 'YYYY-MM-DD');
            item.invoiceDate = utils.formatTime(item.invoiceDate, 'YYYY-MM-DD');
            this.tableData.push(item);
          });
        } else if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        console.log(err);
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true, this.getTotal);
  },
};
</script>
<style lang="less" scoped>
  .btn{
    margin-bottom: 12px
  }
</style>
